// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    name: "Mark Marcos",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed auctor, metus eu congue bibendum, velit nisl blandit quam, id aliquet sem nunc at velit.",
    img: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
  },
  {
    id: 2,
    name: "Mark Farcos",
    description:
      "Proin auctor blandit ipsum, id posuere risus scelerisque in. Nam euismod euismod odio, id malesuada augue auctor id.",
    img: "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
  },
  {
    id: 3,
    name: "Mark Farcos",
    description:
      "Etiam eget ipsum a urna bibendum bibendum. Sed euismod, nibh sit amet viverra bibendum, odio nulla auctor augue, a malesuada ipsum justo eget nibh.",
    img: "https://images.unsplash.com/photo-1583864697784-a0efc8379f70?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80",
  },
  {
    id: 4,
    name: "Mark Farcos",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed auctor, metus eu congue bibendum, velit nisl blandit quam, id aliquet sem nunc at velit.",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
  },
];
